/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A brand's values for the spine token contract. All optional — absent values fall through to platform defaults.
 * @export
 * @interface SurfaceSpineTokens
 */
export interface SurfaceSpineTokens {
    /**
     * Page ground (--bg). Dark surfaces stay neutral — never brown.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    bg?: string;
    /**
     * Second ground (--bg-2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    bg2?: string;
    /**
     * Third ground / first panel step (--bg-3, hub dialect --p1)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    bg3?: string;
    /**
     * Raised panel (--surface, hub dialect --p2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    surface?: string;
    /**
     * Higher panel step (--surface-2, hub dialect --p3)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    surface2?: string;
    /**
     * Hairline border (--line, hub dialect --ln)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    line?: string;
    /**
     * Stronger border (--line-2, hub dialect --ln2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    line2?: string;
    /**
     * Strongest border (--line-3)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    line3?: string;
    /**
     * Body type (--text, hub dialect --tx). Must clear 4.5:1 on bg.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    text?: string;
    /**
     * Secondary type (--text-2, hub dialect --t2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    text2?: string;
    /**
     * Muted type (--text-3, hub dialect --t3)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    text3?: string;
    /**
     * Faintest type (--text-faint)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    textFaint?: string;
    /**
     * Brand accent — FILLS only (--accent, hub dialect --o). Any brand value.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    accent?: string;
    /**
     * Secondary accent (--accent-2, hub dialect --o2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    accent2?: string;
    /**
     * Accent glow/shadow, typically rgba (--accent-glow)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    accentGlow?: string;
    /**
     * Accent as TYPE (--accent-ink). Must clear 4.5:1 on bg — lift the hue until it passes.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    accentInk?: string;
    /**
     * Darkened accent used as the deep stop of fills (--ink). A fill role despite the dialect name.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    accentDeep?: string;
    /**
     * Label ink ON an accent fill — a CTA's text (--octa)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    onAccent?: string;
    /**
     * Count-chip ink on an accent fill (--oi)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    chipInk?: string;
    /**
     * The brand's positive/success mark (--ok). Unset falls through to the platform green.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    ok?: string;
    /**
     * Display face stack (--display, hub dialect --dp)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    displayFont?: string;
    /**
     * Body face stack (--body, hub dialect --bd)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    bodyFont?: string;
    /**
     * Corner radius (--r), e.g. "0px" for a square brand
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    radius?: string;
    /**
     * Secondary radius (--r2)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    radius2?: string;
    /**
     * Notch/bevel size for clip-path shapes (--bv)
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    bevel?: string;
    /**
     * Contested-column height override (--colh), e.g. "498px". Only for surfaces whose column occupant is permanent; omit to keep the structure default.
     * @type {string}
     * @memberof SurfaceSpineTokens
     */
    columnHeight?: string;
    /**
     * Earn-rule category key -> ring color. Emitted as --earn-category-{key}. Keys are the brand's own category vocabulary. A "{key}-ink" entry sets the value pill's TYPE color on that ring (--earn-category-{key}-ink) for rings too bright for white text — the anchor's own purchase/amber move.
     * @type {{ [key: string]: string; }}
     * @memberof SurfaceSpineTokens
     */
    earnCategories?: { [key: string]: string; };
    /**
     * Extra custom properties for ported brand component rules, key without the leading dashes (e.g. "ml-card"). Emitted as --{key}.
     * @type {{ [key: string]: string; }}
     * @memberof SurfaceSpineTokens
     */
    extraVars?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SurfaceSpineTokens interface.
 */
export function instanceOfSurfaceSpineTokens(value: object): value is SurfaceSpineTokens {
    return true;
}

export function SurfaceSpineTokensFromJSON(json: any): SurfaceSpineTokens {
    return SurfaceSpineTokensFromJSONTyped(json, false);
}

export function SurfaceSpineTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceSpineTokens {
    if (json == null) {
        return json;
    }
    return {
        
        'bg': json['bg'] == null ? undefined : json['bg'],
        'bg2': json['bg2'] == null ? undefined : json['bg2'],
        'bg3': json['bg3'] == null ? undefined : json['bg3'],
        'surface': json['surface'] == null ? undefined : json['surface'],
        'surface2': json['surface2'] == null ? undefined : json['surface2'],
        'line': json['line'] == null ? undefined : json['line'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'text': json['text'] == null ? undefined : json['text'],
        'text2': json['text2'] == null ? undefined : json['text2'],
        'text3': json['text3'] == null ? undefined : json['text3'],
        'textFaint': json['textFaint'] == null ? undefined : json['textFaint'],
        'accent': json['accent'] == null ? undefined : json['accent'],
        'accent2': json['accent2'] == null ? undefined : json['accent2'],
        'accentGlow': json['accentGlow'] == null ? undefined : json['accentGlow'],
        'accentInk': json['accentInk'] == null ? undefined : json['accentInk'],
        'accentDeep': json['accentDeep'] == null ? undefined : json['accentDeep'],
        'onAccent': json['onAccent'] == null ? undefined : json['onAccent'],
        'chipInk': json['chipInk'] == null ? undefined : json['chipInk'],
        'ok': json['ok'] == null ? undefined : json['ok'],
        'displayFont': json['displayFont'] == null ? undefined : json['displayFont'],
        'bodyFont': json['bodyFont'] == null ? undefined : json['bodyFont'],
        'radius': json['radius'] == null ? undefined : json['radius'],
        'radius2': json['radius2'] == null ? undefined : json['radius2'],
        'bevel': json['bevel'] == null ? undefined : json['bevel'],
        'columnHeight': json['columnHeight'] == null ? undefined : json['columnHeight'],
        'earnCategories': json['earnCategories'] == null ? undefined : json['earnCategories'],
        'extraVars': json['extraVars'] == null ? undefined : json['extraVars'],
    };
}

export function SurfaceSpineTokensToJSON(json: any): SurfaceSpineTokens {
    return SurfaceSpineTokensToJSONTyped(json, false);
}

export function SurfaceSpineTokensToJSONTyped(value?: SurfaceSpineTokens | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bg': value['bg'],
        'bg2': value['bg2'],
        'bg3': value['bg3'],
        'surface': value['surface'],
        'surface2': value['surface2'],
        'line': value['line'],
        'line2': value['line2'],
        'line3': value['line3'],
        'text': value['text'],
        'text2': value['text2'],
        'text3': value['text3'],
        'textFaint': value['textFaint'],
        'accent': value['accent'],
        'accent2': value['accent2'],
        'accentGlow': value['accentGlow'],
        'accentInk': value['accentInk'],
        'accentDeep': value['accentDeep'],
        'onAccent': value['onAccent'],
        'chipInk': value['chipInk'],
        'ok': value['ok'],
        'displayFont': value['displayFont'],
        'bodyFont': value['bodyFont'],
        'radius': value['radius'],
        'radius2': value['radius2'],
        'bevel': value['bevel'],
        'columnHeight': value['columnHeight'],
        'earnCategories': value['earnCategories'],
        'extraVars': value['extraVars'],
    };
}

